<template>
  <NuxtLayout>
    <NuxtLoadingIndicator color="#00d16a" />
    <NuxtPage />
  </NuxtLayout>
</template>
